import { SET_DASHBOARD } from "../actions/constants";

const defaultState = {
  usersCount: 0,
  verifiedUsersCount: 0,
  walletBalance: 0,
  walletTopups: 0,
  walletWithdrawals: 0,
};

export default (state = defaultState, action) => {
  // const { users, verifiedUsers, balance, topups, withdrawals } = action.payload;
  switch (action.type) {
    case SET_DASHBOARD:
      return {
        // ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
